import { useEffect, useState } from "react";
import axios from "../../axios";
import urls from "../../Utils/urls";
import { LoadingButton } from "../../Utils/CustomComponent";
import { SpinnerBlock } from "../../Utils/CustomComponent";
import { commonToast } from "../../Utils";
import { toast } from "react-toastify";


// Function to generate a random web_password
function generateWebPassword() {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const length = 20; // You can change the length of the password as needed

  let webPassword = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters?.length);
    webPassword += characters[randomIndex];
  }

  return webPassword;
}

function ManageApiKey() {
  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));
  const [loading, setLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState(null);
  const [webPassword, setWebPassword] = useState(null);

  function downloadTextFile(filename, text) {
    const element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(text)
    );
    element.setAttribute("download", filename);
  
    element.style.display = "none";
    document.body.appendChild(element);
  
    element.click();
  
    document.body.removeChild(element);
  }

  useEffect(() => {
    let data = {
      //   "email_address": "dev2.kiran@superiorloanservicing.com"
      email_address: userDetails.email,
    };
    axios
      .post(urls.manageApiKey.postKeyStatus, data)
      .then((response) => {
        if (response.status === 200) {
          setResponseStatus(response.status);
        }
      })
      .catch((error) => {
        //   console.error(error);
        if (error.response.status === 500) {
          setResponseStatus(500);
        }
      });
  }, []);

  const handleCreateApiSubmit = () => {
    const id = toast.loading("Creating an API...");
    setLoading(true);
    const webPassword = generateWebPassword();
    let data = {
      email_address: userDetails.email,
      web_passwrod: webPassword,
    };
    axios
      .post(urls.manageApiKey.postUpdateApi, data)
      .then((response) => {
        setWebPassword(webPassword);
        toast.update(id, {
            render: "API Created Successfully",
            type: "success",
            isLoading: false,
            ...commonToast,
          });
      })
      .catch((error) => {
        // console.error(error);
        toast.update(id, {
            render: "SOME ERROR OCCURED",
            type: "error",
            isLoading: false,
            ...commonToast,
          });
        setWebPassword("");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleGenerateApiSubmit = () => {
    const id = toast.loading("Generating the API...");
    setLoading(true);
    const webPassword = generateWebPassword();
    let data = {
      email_address: userDetails.email,
      first_name: "",
      last_name: "",
      web_password: webPassword,
    };
    axios
      .post(urls.manageApiKey.postRegisterApi, data)
      .then((response) => {
        toast.update(id, {
            render: "API Generated Successfully",
            type: "success",
            isLoading: false,
            ...commonToast,
          });
        setWebPassword(webPassword);
      })
      .catch((error) => {
        setWebPassword("");
        toast.update(id, {
            render: "SOME ERROR OCCURED",
            type: "error",
            isLoading: false,
            ...commonToast,
          });
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="mt-5">
      <h2 className="border-bottom mb-5">Manage API Key</h2>
      <div>
        {!responseStatus && <SpinnerBlock />}
        {responseStatus === 200 ? (
          <div>
            <LoadingButton
              loading={loading}
              type="submit"
              onClick={handleCreateApiSubmit}
              className="text-white mt-5"
              title={"Create new API key"}
              disabled={loading}
            />
            {webPassword && (
             <div className="mt-5">
             <p>Generated API Key: {webPassword}</p>
             <p>Please download the api key. It will not be shown again</p>
             <button
               className="btn btn-primary text-white btn-outline py-4"
               onClick={() => {
                downloadTextFile("api-key.txt", webPassword);
              }}
             >
               Downlaod
             </button>
           </div>
            )}
          </div>
        ) : (
          ""
        )}
        {responseStatus === 500 ? (
          <div>
            <LoadingButton
              loading={loading}
              type="submit"
              onClick={handleGenerateApiSubmit}
              className="text-white mt-5"
              title={"Generate API Key"}
              disabled={loading}
            />
            {webPassword && (
              <div className="mt-5">
                <p>Generated API Key: {webPassword}</p>
                <p>Please download the api key. It will not be shown again</p>
                <button
                  className="btn btn-primary text-white btn-outline py-4"
                  onClick={() => {
                    downloadTextFile("api-key.txt", webPassword);
                  }}
                >
                  Downlaod
                </button>
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default ManageApiKey;
